import * as React from 'react';
import { Searchbar as RNPSearchBar } from 'react-native-paper';

export type SearchBarProps = React.ComponentProps<typeof RNPSearchBar>;

export default function SearchBar(props: SearchBarProps) {
  return <RNPSearchBar {...props} />;
}
